import { render, staticRenderFns } from "./DropdownMenuItem.vue?vue&type=template&id=7ea3141c&scoped=true&"
import script from "./DropdownMenuItem.vue?vue&type=script&lang=ts&"
export * from "./DropdownMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownMenuItem.vue?vue&type=style&index=0&id=7ea3141c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea3141c",
  null
  
)

export default component.exports